<template>
  <b-input-group>
    <b-form-input :type="type" :placeholder="placeholder" :value="value" :disabled="disabled" @input="onInput"/>
    <b-input-group-append class="fa-icon">
      <font-awesome-icon :icon="icon"/>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  props: {
    value: { type: String, default: null },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: null },
    icon: { type: String, require: true },
    disabled: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const onInput = value => emit('input', value)

    return {
      onInput,
    }
  }
}
</script>

<style lang="scss">
.input-group-append.fa-icon {
  background: #efefef;
  width: 50px;
  justify-content: center;
  border: 1px solid #ced4da;

  svg {
    align-self: center;
  }
}
</style>
